import { RouteAbilities, unauthenticatedRoutes } from '~~/app/config/authentication.config';
import { getSafeLoginRedirectPath } from '~~/app/utils/loginRedirect';

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (unauthenticatedRoutes.includes(to.path) || to.path.startsWith('/api/')) {
    return;
  }

  const { data } = await useAuthClient().useSession(useFetch);

  const session = data.value;

  if (session && !session.session?.activeOrganizationId && to.path !== '/logout') {
    const redirect = getSafeLoginRedirectPath(to.fullPath);
    return navigateTo(`/login?redirect=${encodeURIComponent(redirect)}`);
  }

  if (session) {
    const route = Object.keys(RouteAbilities).find((route) => to.path.startsWith(route));
    // Find which abilities are required for this route
    const routeAbility = RouteAbilities[route as keyof typeof RouteAbilities];

    // If no specific restriction → allow access
    if (!routeAbility) {
      return;
    }

    const canAccess = await routeAbility();

    if (!canAccess) {
      return navigateTo(from.path === to.path ? '/' : from.path);
    }
  } else {
    const redirect = getSafeLoginRedirectPath(to.fullPath);
    return navigateTo(`/login?redirect=${encodeURIComponent(redirect)}`);
  }
});
